import 'vant/lib/checkbox/index.less'
import 'vant/lib/checkbox-group/index.less'
// 依赖
import '../preview-text/style'
